import store from "@/store";

export function hasRole(roleSlug) {
  return store.state.mainRole.role.slug === roleSlug;
}
